import {AccountRefWithName} from "@/shared/domain/Account";
import {httpService} from "@/services/HttpService";

class AccountService {
    getAccounts(contactRef: string): Promise<Array<AccountRefWithName>> {
        return httpService.get(`/account/contact/${contactRef}`)
    }
}

export const accountService = new AccountService()